module.exports = __webpack_public_path__ + "static/img/product_tagCard.95b9b39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_tagCard.jpg
// module id = hVcG
// module chunks = 0